import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SnackbarService } from '@services/snackbar/snackbar.service';

@Injectable({ providedIn: 'root' })
export class RoleGuard {
  static readonly canActivate: CanActivateFn = (route, state) => {
    const router = inject(Router); //properly inject Router
    const _snackbar = inject(SnackbarService);
    const userAuth: any = localStorage.getItem('user_auth');

    if (!userAuth) {
      router.navigate(['/unauthorized']);
      return false;
    }

    const roles: any[] = JSON.parse(userAuth)?.role || [];
    const expectedRole = route.data['expectedRole'];

    // Handle both string and array for expectedRole
    const expectedRoles = Array.isArray(expectedRole)
      ? expectedRole.map((r) => r.toLowerCase())
      : [expectedRole.toLowerCase()];

    // Check if user has any matching role
    const hasAccess = roles.some((r: any) =>
      expectedRoles.includes(r.roleName.toLowerCase())
    );

    if (!hasAccess) {
      _snackbar.notify('Access denied: insufficient role', 2);
      router.navigate(['/auth/login']);
    }

    return hasAccess;
  };
}
